import { Resource, CombineResource } from "restdux";
import { getAPIUrl, getHeaders, transformIndex } from "../global/globals";

export interface IReturn {
	agency: string;
	description: string;
	id: number;
	note: string;
	employer?: number;
	network?: number;
	pricing: number;
}

export type ISend = Partial<IReturn>;

export interface IParameters {}

const resource = Resource<IParameters, ISend, IReturn>({
	batchReads: true,
	headers: getHeaders,
	methodUpdate: "PATCH",
	name: "transactiontype",
	rootUrl: getAPIUrl("/transactiontypes"),
	transformIndex,
});

export const { actions, types, reducer } = CombineResource(resource, {});
